export default {
  facilityName: 'Facility name',
  facility: 'Facility',
  facilityCategory: 'Facility category',
  facilityID: 'Facility ID',
};
